/**
 * Auth form input helpers.
 *
 * Pure string utilities for the sign-up/log-in flow
 * (pages/user/SignUpOrLogIn.tsx): live-formats US phone numbers as
 * "+1 (XXX) XXX-XXXX" while typing, sanitizes usernames to
 * letters/numbers/periods/underscores, and strips phone input down to
 * "+" and digits for submission.
 */
export function formatPhoneNumberForInput(value: string): string {
    if (!value.startsWith("+1 ")) {
        return "+1 ";
    } else {
        const numbers = value.slice(3).replace(/\D/g, "").slice(0, 10);
        let formatted = "+1 ";
        if (numbers.length > 0) {
            formatted += "(";
            formatted += numbers.slice(0, 3);
            if (numbers.length > 3) {
                formatted += ") ";
                formatted += numbers.slice(3, 6);
                if (numbers.length > 6) {
                    formatted += "-";
                    formatted += numbers.slice(6, 10);
                }
            }
        }
        return formatted;
    }
}

export function sanitizeUsername(value: string): string {
    // Only allow letters, numbers, periods, and underscores
    const sanitized = value.replace(/[^a-zA-Z0-9._]/g, "");
    return sanitized;
}

export function stripToPlusAndDigits(input: string): string {
    // Use a regular expression to match any character that is NOT a digit or '+'
    // and replace it with an empty string.
    return input.replace(/[^+\d]/g, "");
}
